import { usePermissionStore } from "controller/store/PermissionStore";
import { UnautherizedScreen } from "pages/error-screens/UnautherizedScreen";
import { ReactNode, useMemo } from "react";
import { Navigate } from "react-router-dom";

interface PermissionListProps {
  permissions: string[];
  operator: "AND" | "OR";
}

export const PermissionWrapper = ({
  permission,
  children,
  operator = "AND",
}: {
  permission: string | string[] | Array<PermissionListProps>;
  children: ReactNode;
  operator?: "AND" | "OR";
}) => {
  const hasPermissions = usePermissionStore((state) => state.hasPermissions);

  // const havePermission = usePermissionStore((state) =>
  //   state.hasPermissions(
  //     Array.isArray(permission) ? permission : [permission],
  //     operator
  //   )
  // );
  const getPermission = () => {
    if (Array.isArray(permission)) {
      if (permission.length > 0 && typeof permission[0] === "string") {
        return hasPermissions(permission as string[], operator);
      } else if (permission.length > 0 && typeof permission[0] === "object") {
        const resultList = (permission as Array<PermissionListProps>).map(
          (item: PermissionListProps) => {
            return hasPermissions(item.permissions, item.operator);
          },
        );
        return operator === "AND"
          ? resultList.every((item) => item)
          : resultList.some((item) => item);
      }
    }
    if (typeof permission === "string") {
      return hasPermissions([permission], operator);
    }
  };

  const havePermission = getPermission();

  return <>{havePermission ? children : <UnautherizedScreen />}</>;
};
